// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
// import Waypoint from 'react-waypoint'

// Internal Dependencies:
// import SectionTransitionWaves from 'containers/SectionTransitionWaves'
import Waypoint from 'components/Waypoint/Waypoint'
import WaypointDistance from 'components/Waypoint/WaypointDistance'
import Link from 'components/Link/Link'
import ArrowR from 'components/svg/arrows/arrow-right.svg'
import LongArrowLHead from 'components/svg/arrows/left.svg'
import LongArrowRHead from 'components/svg/arrows/right.svg'
import LongArrowL from 'components/svg/arrows/long-arrow-left.svg'
import LongArrowR from 'components/svg/arrows/long-arrow-right.svg'
import { jsonEqual } from 'utilities/objects'

// Events:
// const doSectionWavesTransitionRightToLeft = document.createEvent( 'Event' )
// doSectionWavesTransitionRightToLeft.initEvent( 'doSectionWavesTransitionRightToLeft', true, true )

// const doSectionWavesTransitionLeftToRight = document.createEvent( 'Event' )
// doSectionWavesTransitionLeftToRight.initEvent( 'doSectionWavesTransitionLeftToRight', true, true )

class ContentSliderB extends React.Component {
	constructor( props ) {
		super( props )

		let slides = [],
			slidesCount = 1,
			slidesCountDisplay = '01',
			activeSlideData = {}

		if ( props.slides && props.slides.length ) {
			slidesCount = props.slides.length
			slidesCountDisplay = this.padNumber( slidesCount )
			activeSlideData = props.slides[ 0 ]
		}

		this.state = {
			withinSlider: false,
			slides: props.slides,
			slidesCount,
			slidesCountDisplay,
			activeSlide: 1,
			activeSlideDisplay: '01',
			activeSlideData
		}

		this.activeSlide = 1
		this.refInner = React.createRef()
	}

	componentDidMount() {
		const { siteHasLoaded } = this.props
		const { slides } = this.state
		const loadDelay = siteHasLoaded ? 1000 : siteData.loading_delay_seconds * 1000

		const newSlideData = slides[ 0 ]

		if ( newSlideData.type ) {
			// document.documentElement.classList.add( `content-type-${newSlideData.type}` )
		}

		setTimeout( () => {
			this.setSlidesAnimations()
		}, 1000 )

		// setTimeout( () => {
		// 	this.setSlideAnimations()
		// }, loadDelay )
	}

	componentWillUnmount() {
		clearInterval( this.interval )
		document.removeEventListener( 'mousemove', this.handleMouseMove )
	}

	componentDidUpdate() {
		const { slides } = this.props

		if ( ! jsonEqual( slides, this.state.slides ) ) {
			this.setState( {
				slides
			} )
		}
	}

	selectPrev = () => {
		this.changeSlideDirection( 'prev' )
	}

	selectNext = ( e = false ) => {
		this.changeSlideDirection( 'next' )
	}

	changeSlideDirection = ( direction ) => {
		const { slidesCount, activeSlide } = this.state
		let activeSlideNew

		if ( 'next' == direction ) {
			activeSlideNew = this.activeSlide == slidesCount ? 1 : this.activeSlide + 1
		} else {
			activeSlideNew = this.activeSlide == 1 ? slidesCount : this.activeSlide - 1
		}

		this.changeSlide( activeSlideNew, direction )
	}

	changeSlide = ( activeSlideNew, direction = 'next' ) => {
		const { slides, activeSlide } = this.state

		const prevSlideData = slides[ this.activeSlide - 1 ]
		const newSlideData = slides[ activeSlideNew - 1 ]
		let changeSlideDelay = 1

		changeSlideDelay = 1000

		if ( 'next' == direction ) {
			// window.dispatchEvent( doSectionWavesTransitionRightToLeft )
		} else {
			// window.dispatchEvent( doSectionWavesTransitionLeftToRight )
		}

		// setTimeout( () => {
			this.activeSlide = activeSlideNew

			this.setState( {
				activeSlide: activeSlideNew,
				activeSlideDisplay: this.padNumber( activeSlideNew ),
				activeSlideData: newSlideData
			} )

			// setTimeout( () => {
			// 	this.setSlideAnimations()
			// }, 700 )
		// }, changeSlideDelay )

		if ( prevSlideData.type ) {
			// document.documentElement.classList.remove( `content-type-${prevSlideData.type}` )
		}

		if ( newSlideData.type ) {
			// document.documentElement.classList.add( `content-type-${newSlideData.type}` )
		}
	}

	onEnterSlider = () => {
		this.setState( {
			withinSlider: true
		} )
	}

	onLeaveSlider = () => {
		this.setState( {
			withinSlider: false
		} )
	}

	onEnterSlide = ( slideNumber ) => {
		const { activeSlide } = this.state

		if ( this.activeSlide == slideNumber ) {
			return
		}

		this.changeSlide( slideNumber )
	}

	onLeaveSlide = ( slideNumber ) => {
		return
	}

	handleChangeSlideDistance = ( distance, slideNumber ) => {
		const { slidesCount } = this.state

		if ( this.activeSlide >= slidesCount ) {
			return
		}

		// if ( 1 == slideNumber ) {
		// 	console.log( slideNumber, distance )
		// }

		// const contentElement = document.querySelector( `.js-slide-content-${slideNumber} .js-slide-content-bg` )

		// if ( ! contentElement ) {
		// 	return
		// }

		// contentElement.style.opacity = this.calculateOpacity( distance )

		if ( slideNumber == this.activeSlide ) {
			const imageElement = document.querySelector( `.js-slide-image-${slideNumber} .js-content-slider-image` )

			if ( distance < 0 ) {
				distance = 0
			}

			if ( imageElement ) {
				imageElement.style.clipPath = this.calculateClipPath( distance )
			}
		}

		// if ( distance >= 0 && slideNumber == this.activeSlide ) {
		// 	const imageElement = document.querySelector( `.js-slide-image-${slideNumber} .js-content-slider-image` )

		// 	if ( imageElement ) {
		// 		imageElement.style.clipPath = this.calculateClipPath( distance )
		// 	}
		// }
	}

	// calculateOpacity = ( distance ) => {
	// 	if ( distance === 0 ) return 1
	// 	if ( Math.abs( distance ) >= window.innerHeight / 2 ) return 0

	// 	return 1 - Math.abs( distance ) / ( window.innerHeight / 2 )
	// }

	calculateClipPath = ( distance ) => {
		const maxDistance = window.innerHeight / 2
		const normalizedDistance = Math.min( Math.abs( distance ) / maxDistance, 1 )
		// const clipPercentage = ( 1 - normalizedDistance ) * 100
		const clipPercentage = normalizedDistance * 100

		// return `polygon( 0% 0%, 100% 0%, 100% ${clipPercentage}%, 0% ${clipPercentage}% )`
		return `inset( 0% 0% ${clipPercentage}% 0% )`
	}

	setSlidesAnimations = () => {
		// const { activeSlide } = this.state
		const imageElements = document.querySelectorAll( '.js-content-slider-image' )

		if ( ! imageElements ) {
			return
		}

		document.addEventListener( 'mousemove', this.handleMouseMove )
	}

	setSlideAnimations = () => {
		const { activeSlideData } = this.state
	}

	handleMouseMove = ( e ) => {
		const imageElement = document.querySelector( '.js-slide-image.is-active .js-content-slider-image' )

		if ( ! imageElement ) {
			return
		}

		const imageElementForeground = document.querySelector( '.js-slide-image.is-active .js-content-slider-image-foreground' )
		const panelRect = imageElement.getBoundingClientRect()

		const imageContainerWidth = window.innerWidth
		const imageContainerHeight = window.innerHeight

		const factorBg = 0.05
		const factorFg = 0.2
		let imageElementCenterX = imageElement.offsetLeft + ( imageElement.offsetWidth / 2 ),
			imageElementCenterY = imageElement.offsetTop + ( imageElement.offsetHeight / 2 )

		let mousePosX = Math.floor( e.clientX - panelRect.left ) / ( panelRect.right - panelRect.left ) * imageContainerWidth,
			mousePosY = Math.floor( e.clientY - panelRect.top ) / ( panelRect.bottom - panelRect.top ) * imageContainerHeight

		let distX = mousePosX - imageElementCenterX,
			distY = mousePosY - imageElementCenterY

		// imageElement.style.transform = `translate(${ ( -1 * ( distX * factorBg ) ) / 12 }px, ${ ( -1 * ( distY * factorBg ) ) / 12 }px)`

		if ( imageElementForeground ) {
			imageElementForeground.style.transform = `translate(${ ( -1 * ( distX * factorFg ) ) / 12 }px, ${ ( -1 * ( distY * factorFg ) ) / 12 }px)`
		}
	}

	padNumber = ( number ) => {
		if ( number >= 10 ) {
			return number
		}

		return `0${number}`
	}

	renderNav = () => {
		const { activeSlideData, slidesCount } = this.state
		let className = '-nav'
		let percentEach = ( 100 / slidesCount )
		let height = 108 / slidesCount
		let currentPercent = ( percentEach * this.activeSlide ) - percentEach
		let styleDot = {
			transform: `translateY( ${currentPercent}% )`
		}
		let styleDotInner = {
			height: `${height}px`,
		}

		if ( activeSlideData ) {
			className += ` is-type-${activeSlideData.type}`
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-bar">
						<div className="-dot" style={ styleDot }>
							<div className="-inner" style={ styleDotInner }></div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderContent = () => {
		const { data, isMobile } = this.props
		const { slides, slidesCountDisplay, activeSlide, activeSlideDisplay, activeSlideData } = this.state

		return slides.map( ( item, i ) => {
			let current = i + 1,
				nextData = slides[ i + 1 ],
				className = this.activeSlide == current ? '-slide js-slide-content is-active' : '-slide js-slide-content'

			className += ` js-slide-content-${current}`
			className += ` is-type-${item.type}`

			let styleBgMobile = {},
				// styleBgJoinMobileFirst = {},
				styleBgJoinMobile = {}

			if ( item.bg_mobile ) {
				let nextBg = nextData ? nextData.bg_mobile : '#fff'
				styleBgMobile.background = item.bg_mobile
				// styleBgJoinMobileFirst.background = `linear-gradient( 180deg, ${item.bg}, transparent )`
				styleBgJoinMobile.background = `linear-gradient( 180deg, ${item.bg_mobile}, ${nextBg} )`
			}

			return (
				<React.Fragment>
					{ ( 1 === current ) &&
						<div className="-bg-join-mobile" style={ { background: `linear-gradient( 180deg, #fff, ${item.bg_mobile} )` } }></div>
					}

					<div className={ className } key={ i }>
						{ ! isMobile &&
							<React.Fragment>
								<Waypoint
									onEnter={ () => {
										this.onEnterSlide( current )
									} }
									onLeave={ () => {
										this.onLeaveSlide( current )
									} }
								/>

								<WaypointDistance onChange={ this.handleChangeSlideDistance } data={ current } />
							</React.Fragment>
						}

						{/*<div className="-bg js-slide-content-bg" style={ style }></div>*/}
						<div className="-bg-mobile" style={ styleBgMobile }></div>

						<div className="-inner">
							<div className="-text">
								<div className="-title">
									{ item.subtitle &&
										<p className="subtitle">{ item.subtitle }</p>
									}

									<h2>{ item.title }</h2>
								</div>

								<h4 className="-text-content" dangerouslySetInnerHTML={ { __html: item.content } } />

								<Link to={ item.url } className="circle-button is-hidden"><span>View</span><ArrowR /></Link>
							</div>

							<div className="-image-mobile">
								{ this.renderImage( item, true ) }
							</div>
						</div>
					</div>

					<div className="-bg-join-mobile" style={ styleBgJoinMobile }></div>
				</React.Fragment>
			)
		} )
	}

	renderImages = () => {
		const { data } = this.props
		const { slides, slidesCountDisplay, activeSlide, activeSlideDisplay } = this.state

		return slides.map( ( item, i ) => {
			let current = i + 1,
				className = this.activeSlide == current ? '-slide js-slide-image is-active' : '-slide js-slide-image'

			className += ` js-slide-image-${current}`

			return (
				<div className={ className } style={ {} } key={ i }>
					{ this.renderImage( item ) }
				</div>
			)
		} )
	}

	renderImage = ( item, isMobile = false ) => {
		if ( ! item.image || ! item.image.url ) {
			return
		}

		let imageClassSuffix = '',
			imageBStyle = {},
			imageBImgStyle = {}

		if ( 'cover' == item.image_type ) {
			imageClassSuffix = '-cover-3'
		}

		if ( isMobile ) {
			if ( item.image_b_mobile_max_width ) {
				imageBImgStyle.maxWidth = item.image_b_mobile_max_width
			}

			if ( item.image_b_mobile_offset_bottom ) {
				imageBImgStyle.bottom = item.image_b_mobile_offset_bottom
			}
		} else {
			if ( item.image_b_max_height ) {
				imageBStyle.maxHeight = item.image_b_max_height
			}

			if ( item.image_b_offset_top ) {
				imageBStyle.top = item.image_b_offset_top
			}

			if ( item.image_b_offset_left ) {
				imageBStyle.left = item.image_b_offset_left
			}
		}

		return (
			<Link to={ item.url } className={ `-image${imageClassSuffix}` }>
				<img className={ `js-content-slider-image${imageClassSuffix}` } src={ item.image.url } alt={ item.image.alt } width={ item.image.width } height={ item.image.height } />

				{ ( item.image_b && item.image_b.url ) &&
					<div className="-image-b" style={ imageBStyle }>
						<img className={ `js-content-slider-image-foreground` } src={ item.image_b.url } alt={ item.image_b.alt } width={ item.image_b.width } height={ item.image_b.height } style={ imageBImgStyle } />
					</div>
				}
			</Link>
		)
	}

	render() {
		const { data } = this.props
		const { withinSlider, activeSlide, activeSlideData, slidesCount } = this.state
		let slidesClass = this.activeSlide == slidesCount ? '-slides has-last-active' : '-slides'
		let style = {}

		if ( 1 == this.activeSlide ) {
			slidesClass += ' has-first-active'
		}

		if ( activeSlideData.bg ) {
			style.background = activeSlideData.bg
		}

		if ( ! withinSlider ) {
			style.background = '#fff'
		}

		return (
			<div className="section-content-slider">
				<div className="-inner" ref={ this.refInner }>
					<div className={ slidesClass } style={ style }>
						<Waypoint
							className="-waypoint-before"
							threshold={ 0 }
							checkIntersectionRatio={ false }
							onEnter={ () => {
								this.onLeaveSlider()
							} }
							onLeave={ () => {
								this.onEnterSlider()
							} }
						/>

						<div className="-before" style={ style } />
						<div className="-after" style={ style } />

						{ this.renderNav() }

						<div className="-slides-content">
							{ this.renderContent() }
						</div>

						<div className="-slides-images">
							<div className="-inner">
								{ this.renderImages() }
							</div>
						</div>

						<Waypoint
							className="-waypoint-after"
							threshold={ 0 }
							checkIntersectionRatio={ false }
							onEnter={ () => {
								this.onLeaveSlider()
							} }
							onLeave={ () => {
								this.onEnterSlider()
							} }
						/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		siteHasLoaded: state.site.siteHasLoaded,
		isMobile: state.site.isMobile,
	}
}

export default connect( mapStateToProps )( ContentSliderB )



// WEBPACK FOOTER //
// ./components/PageSections/ContentSliderB.jsx